import {Card} from 'platform/components';
import {Box} from 'platform/foundation';
import {match} from 'ts-pattern';

import {useCallback} from 'react';

import {head, mergeAll} from 'ramda';
import {isArray} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {warehouseRoutes} from '@dms/routes';
import {DmsDataGrid, Section, catchUnhandledDataGridActions} from '@dms/shared';
import {useWarehouseParams} from '@dms/warehouse/shared-components';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback, QueryFilterObject} from 'features/eag-grid';

export function IssueNotes() {
  const {transferOrderId} = useWarehouseParams();

  const navigate = useNavigate();

  const actionCallback: ActionCallback = ({actionKey, rowId}) => {
    const issueNoteId = isArray(rowId) ? head(rowId) : rowId;

    match(actionKey)
      .with('redirectDetail', () =>
        navigate(
          composePath(warehouseRoutes.issueNoteDetailOverview, {
            params: {id: issueNoteId},
            isSearchParamsPreserved: false,
          })
        )
      )
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {originDocId: transferOrderId}]),
    [transferOrderId]
  );

  return (
    <Section isFullHeight>
      <Card isFullHeight title={i18n.t('page.warehouse.labels.issueNotes')}>
        <Box height="100%">
          <DmsDataGrid
            gridCode={GRID_CODE}
            emptyState={{headline: i18n.t('general.labels.noData')}}
            actionCallback={actionCallback}
            queryModifier={queryModifier}
            data-testid={GRID_CODE}
          />
        </Box>
      </Card>
    </Section>
  );
}

const GRID_CODE = 'issue-notes-list';
